module.exports = __webpack_public_path__ + "img/136.dda81b74.jpg";